<div class="top-header-beta" *ngIf="environmentVariables?.ENABLE_SOFTBAR" style="z-index: 99;position: relative;">
    <img  loading="lazy" 
        [src]="environmentVariables?.SOFTBAR_ICON"
           alt="softbar image"
        *ngIf="environmentVariables?.SOFTBAR_ICON"
        class="mx-1"
    />
    <p>
        {{
            lang == "en"
                ? environmentVariables?.SOFTBAR_TEXT_EN
                : environmentVariables?.SOFTBAR_TEXT_AR
        }}
    </p>
</div>
